module.exports = __webpack_public_path__ + "static/media/main_2.ba4a283c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/main_2.jpg
// module id = 891
// module chunks = 0